export default "5140b2d928ee3408.png"